export const SAVE_MATCH_COMPLETE = "SAVE_MATCH_COMPLETE";
export const DELETE_MATCH_COMPLETE = "DELETE_MATCH_COMPLETE";
export const GET_MATCHES = "GET_MATCHES";
export const GET_MATCHES_COMPLETE = "GET_MATCHES_COMPLETE";
export const EDIT_MATCH_COMPLETE = "EDIT_MATCH_COMPLETE";
